const STORAGE_KEY = "hiddenNewsIds";

export function getHiddenNewsIds() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
}

export function hideNewsLocally(newsOrId) {
  const id =
    typeof newsOrId === "object" && newsOrId !== null
      ? newsOrId._id || newsOrId.newsId
      : newsOrId;

  if (!id) return;

  const hidden = getHiddenNewsIds();
  if (!hidden.includes(id)) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify([...hidden, id]));
  }
}

export function filterHiddenNews(items) {
  const hidden = new Set(getHiddenNewsIds());
  return (items || []).filter(
    (item) => !hidden.has(item._id) && !hidden.has(item.newsId)
  );
}
